export const valueTranslationPrefix = '$i18n$';

/**
 * Serviço de tradução de conteúdo de objetos.
 *
 * Somente serão traduzidas as propriedades do objeto que forem strings com prefixo igual a
 * valueTranslationPrefix, seguido da chave de tradução.
 * As demais propriedades permanecerão inalteradas.
 *
 * @param {Object} obj Objeto a ser traduzido.
 * @returns {Object} Novo objeto com propriedades traduzidas.
 */
function translateObjectContent(obj) {
  const newObj = {};
  Object.keys(obj).forEach((prop) => {
    const value = obj[prop];
    if (typeof value === 'string' && value.startsWith(valueTranslationPrefix)) {
      newObj[prop] = this.$t(value.substr(valueTranslationPrefix.length));
    } else {
      newObj[prop] = value;
    }
  });
  return newObj;
}

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $toc: {
        get: () => translateObjectContent,
      },
    });
  },
};
